import _toConsumableArray from "D:\\a\\1\\s\\TP.DocumentGenerator.Web\\ClientApp\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _defineProperty from "D:\\a\\1\\s\\TP.DocumentGenerator.Web\\ClientApp\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "D:\\a\\1\\s\\TP.DocumentGenerator.Web\\ClientApp\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "D:\\a\\1\\s\\TP.DocumentGenerator.Web\\ClientApp\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "D:\\a\\1\\s\\TP.DocumentGenerator.Web\\ClientApp\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import * as React from 'react';
import { createContext, useContext, createElement } from 'react';

var isCheckBoxInput = function isCheckBoxInput(type) {
  return type === 'checkbox';
};

function attachEventListeners(_ref) {
  var field = _ref.field,
      validateAndStateUpdate = _ref.validateAndStateUpdate,
      isRadio = _ref.isRadio;
  var ref = field.ref;
  if (!ref.addEventListener) return;
  ref.addEventListener(isCheckBoxInput(ref.type) || isRadio ? 'change' : 'input', validateAndStateUpdate);
  ref.addEventListener('blur', validateAndStateUpdate);
}

var isObject = function isObject(value) {
  return typeof value === 'object';
};

var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/;
var reIsPlainProp = /^\w*$/;
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var reEscapeChar = /\\(\\)?/g;
var reIsUint = /^(?:0|[1-9]\d*)$/;
var isArray = Array.isArray;

function isIndex(value) {
  return reIsUint.test(value) && value > -1;
}

function isKey(value) {
  if (isArray(value)) return false;
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value);
}

var stringToPath = function stringToPath(string) {
  var result = [];
  string.replace(rePropName, function (match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
};

function set(object, path, value) {
  path = isKey(path) ? [path] : stringToPath(path);
  var index = -1;
  var length = path.length;
  var lastIndex = length - 1;

  while (++index < length) {
    var key = path[index];
    var newValue = value;

    if (index != lastIndex) {
      var objValue = object[key];
      newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
    }

    object[key] = newValue;
    object = object[key];
  }

  return object;
}

var combineFieldValues = function combineFieldValues(data) {
  return Object.entries(data).reduce(function (previous, _ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];

    if (key.match(/\[\d+\]/gi) || key.indexOf('.')) {
      set(previous, key, value);
      return previous;
    }

    previous[key] = value;
    return previous;
  }, {});
};

var removeAllEventListeners = function removeAllEventListeners(ref, validateWithStateUpdate) {
  if (!ref.removeEventListener) return;
  ref.removeEventListener('input', validateWithStateUpdate);
  ref.removeEventListener('change', validateWithStateUpdate);
  ref.removeEventListener('blur', validateWithStateUpdate);
};

var isRadioInput = function isRadioInput(type) {
  return type === 'radio';
};

function findRemovedFieldAndRemoveListener(fields, touchedFieldsRef, fieldsWithValidationRef, validateWithStateUpdate, _ref4) {
  var ref = _ref4.ref,
      mutationWatcher = _ref4.mutationWatcher,
      options = _ref4.options;
  var forceDelete = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  if (!ref || !ref.type) return;
  var name = ref.name,
      type = ref.type;
  var isRefDeleted = !document.body.contains(ref);
  touchedFieldsRef.current.delete(name);
  fieldsWithValidationRef.current.delete(name);

  if (isRadioInput(type) && options) {
    options.forEach(function (_ref5, index) {
      var ref = _ref5.ref;

      if (ref instanceof HTMLElement && isRefDeleted && options[index]) {
        removeAllEventListeners(options[index], validateWithStateUpdate);
        (options[index].mutationWatcher || {
          disconnect: function disconnect() {}
        }).disconnect();
        options.splice(index, 1);
      }
    });
    if (!options.length) delete fields[name];
  } else if (ref instanceof HTMLElement && isRefDeleted || forceDelete) {
    removeAllEventListeners(ref, validateWithStateUpdate);
    if (mutationWatcher) mutationWatcher.disconnect();
    delete fields[name];
  }
}

var defaultReturn = {
  isValid: false,
  value: ''
};

function getRadioValue(options) {
  return Array.isArray(options) ? options.reduce(function (previous, _ref6) {
    var _ref6$ref = _ref6.ref,
        checked = _ref6$ref.checked,
        value = _ref6$ref.value;
    return checked ? {
      isValid: true,
      value: value
    } : previous;
  }, defaultReturn) : defaultReturn;
}

var getMultipleSelectValue = function getMultipleSelectValue(options) {
  return options.filter(function (_ref7) {
    var selected = _ref7.selected;
    return selected;
  }).map(function (_ref8) {
    var value = _ref8.value;
    return value;
  });
};

function getFieldValue(fields, _ref9) {
  var type = _ref9.type,
      name = _ref9.name,
      options = _ref9.options,
      checked = _ref9.checked,
      value = _ref9.value;

  if (isRadioInput(type)) {
    var field = fields[name];
    return field ? getRadioValue(field.options).value : '';
  }

  if (type === 'select-multiple') return getMultipleSelectValue(options);
  if (isCheckBoxInput(type)) return checked ? value || checked : false;
  return value;
}

var isString = function isString(value) {
  return value && typeof value === 'string';
};

function getFieldsValue(fields, fieldName) {
  return Object.values(fields).reduce(function (previous, _ref10) {
    var ref = _ref10.ref,
        name = _ref10.ref.name;
    var value = getFieldValue(fields, ref);
    if (isString(fieldName)) return name === fieldName ? value : previous;

    if (!fieldName) {
      previous[name] = value;
    } else if (Array.isArray(fieldName) && fieldName.includes(name)) {
      previous[name] = value;
    }

    return previous;
  }, {});
}

var isEmptyObject = function isEmptyObject(values) {
  return values && values.constructor === Object && Object.keys(values).length === 0;
};

function shouldUpdateWithError(_ref11) {
  var errors = _ref11.errors,
      name = _ref11.name,
      error = _ref11.error,
      isOnBlur = _ref11.isOnBlur,
      isBlurType = _ref11.isBlurType,
      isValidateDisabled = _ref11.isValidateDisabled;

  if (isValidateDisabled || isOnBlur && !isBlurType || isEmptyObject(error) && isEmptyObject(errors) || errors[name] && errors[name].isManual) {
    return false;
  }

  if (isEmptyObject(errors) && !isEmptyObject(error) || isEmptyObject(error) && errors[name] || !errors[name]) {
    return true;
  }

  return errors[name] && error[name] && (errors[name].type !== error[name].type || errors[name].message !== error[name].message);
}

var getValueAndMessage = function getValueAndMessage(item) {
  return {
    value: typeof item === 'object' && item.value ? item.value : item,
    message: typeof item === 'object' && item.message ? item.message : ''
  };
};

var displayNativeError = function displayNativeError(nativeValidation, ref, message) {
  if (nativeValidation && isString(message)) ref.setCustomValidity(message);
};

var DATE_INPUTS = ['date', 'time', 'month', 'datetime', 'datetime-local', 'week'];
var STRING_INPUTS = ['text', 'email', 'password', 'search', 'tel', 'url', 'textarea'];
var VALIDATION_MODE = {
  onBlur: 'onBlur',
  onchange: 'onChange',
  onSubmit: 'onSubmit'
};

var validateField =
/*#__PURE__*/
function () {
  var _ref13 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(_ref12, fields, nativeValidation) {
    var ref, _ref12$ref, type, value, name, checked, options, required, maxLength, minLength, min, max, pattern, validate, error, isRadio, isCheckBox, isSelectOrInput, nativeError, isStringInput, exceedMax, exceedMin, valueNumber, _getValueAndMessage, maxValue, maxMessage, _getValueAndMessage2, minValue, minMessage, message, _getValueAndMessage3, maxLengthValue, maxLengthMessage, _getValueAndMessage4, minLengthValue, minLengthMessage, inputLength, _exceedMax, _exceedMin, _message, _getValueAndMessage5, patternValue, patternMessage, fieldValue, validateRef, result, validationResult;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            ref = _ref12.ref, _ref12$ref = _ref12.ref, type = _ref12$ref.type, value = _ref12$ref.value, name = _ref12$ref.name, checked = _ref12$ref.checked, options = _ref12.options, required = _ref12.required, maxLength = _ref12.maxLength, minLength = _ref12.minLength, min = _ref12.min, max = _ref12.max, pattern = _ref12.pattern, validate = _ref12.validate;
            error = {};
            isRadio = isRadioInput(type);
            isCheckBox = isCheckBoxInput(type);
            isSelectOrInput = !isCheckBox && !isRadio;
            nativeError = displayNativeError.bind(null, nativeValidation, ref);
            isStringInput = STRING_INPUTS.includes(type);

            if (!(required && (isCheckBox && !checked || isSelectOrInput && value === '' || isRadio && !getRadioValue(fields[name].options).isValid || !type && !value))) {
              _context2.next = 11;
              break;
            }

            error[name] = {
              type: 'required',
              message: isString(required) ? required : '',
              ref: isRadio ? (fields[name].options || [{
                ref: ''
              }])[0].ref : ref
            };
            nativeError(required);
            return _context2.abrupt("return", error);

          case 11:
            if (!((min || max) && !isStringInput)) {
              _context2.next = 21;
              break;
            }

            valueNumber = parseFloat(value);
            _getValueAndMessage = getValueAndMessage(max), maxValue = _getValueAndMessage.value, maxMessage = _getValueAndMessage.message;
            _getValueAndMessage2 = getValueAndMessage(min), minValue = _getValueAndMessage2.value, minMessage = _getValueAndMessage2.message;
            message = exceedMax ? maxMessage : minMessage;

            if (type === 'number') {
              exceedMax = maxValue && valueNumber > maxValue;
              exceedMin = minValue && valueNumber < minValue;
            } else if (DATE_INPUTS.includes(type)) {
              if (typeof maxValue === 'string') exceedMax = maxValue && new Date(value) > new Date(maxValue);
              if (typeof minValue === 'string') exceedMin = minValue && new Date(value) < new Date(minValue);
            }

            if (!(exceedMax || exceedMin)) {
              _context2.next = 21;
              break;
            }

            error[name] = {
              type: exceedMax ? 'max' : 'min',
              message: message,
              ref: ref
            };
            nativeError(message);
            return _context2.abrupt("return", error);

          case 21:
            if (!((maxLength || minLength) && isStringInput)) {
              _context2.next = 32;
              break;
            }

            _getValueAndMessage3 = getValueAndMessage(maxLength), maxLengthValue = _getValueAndMessage3.value, maxLengthMessage = _getValueAndMessage3.message;
            _getValueAndMessage4 = getValueAndMessage(minLength), minLengthValue = _getValueAndMessage4.value, minLengthMessage = _getValueAndMessage4.message;
            inputLength = value.toString().length;
            _exceedMax = maxLength && inputLength > maxLengthValue;
            _exceedMin = minLength && inputLength < minLengthValue;
            _message = _exceedMax ? maxLengthMessage : minLengthMessage;

            if (!(_exceedMax || _exceedMin)) {
              _context2.next = 32;
              break;
            }

            error[name] = {
              type: _exceedMax ? 'maxLength' : 'minLength',
              message: _message,
              ref: ref
            };
            nativeError(_message);
            return _context2.abrupt("return", error);

          case 32:
            if (!pattern) {
              _context2.next = 38;
              break;
            }

            _getValueAndMessage5 = getValueAndMessage(pattern), patternValue = _getValueAndMessage5.value, patternMessage = _getValueAndMessage5.message;

            if (!(patternValue instanceof RegExp && !patternValue.test(value))) {
              _context2.next = 38;
              break;
            }

            error[name] = {
              type: 'pattern',
              message: patternMessage,
              ref: ref
            };
            nativeError(patternMessage);
            return _context2.abrupt("return", error);

          case 38:
            if (!validate) {
              _context2.next = 58;
              break;
            }

            fieldValue = isRadio ? getRadioValue(options).value : value;
            validateRef = isRadio && options ? options[0].ref : ref;

            if (!(typeof validate === 'function')) {
              _context2.next = 51;
              break;
            }

            _context2.next = 44;
            return validate(fieldValue);

          case 44:
            result = _context2.sent;

            if (!(isString(result) && result || typeof result === 'boolean' && !result)) {
              _context2.next = 49;
              break;
            }

            error[name] = {
              type: 'validate',
              message: isString(result) ? result : '',
              ref: validateRef
            };
            nativeError(result);
            return _context2.abrupt("return", error);

          case 49:
            _context2.next = 58;
            break;

          case 51:
            if (!isObject(validate)) {
              _context2.next = 58;
              break;
            }

            _context2.next = 54;
            return new Promise(function (resolve) {
              var values = Object.entries(validate);
              values.reduce(
              /*#__PURE__*/
              function () {
                var _ref15 = _asyncToGenerator(
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee(previous, _ref14, index) {
                  var _ref16, key, validate, lastChild, _result, _message2, data;

                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _ref16 = _slicedToArray(_ref14, 2), key = _ref16[0], validate = _ref16[1];
                          lastChild = values.length - 1 === index;

                          if (!(typeof validate === 'function')) {
                            _context.next = 11;
                            break;
                          }

                          _context.next = 5;
                          return validate(fieldValue);

                        case 5:
                          _result = _context.sent;

                          if (!(typeof _result !== 'boolean' || !_result)) {
                            _context.next = 11;
                            break;
                          }

                          _message2 = isString(_result) ? _result : '';
                          data = {
                            type: key,
                            message: _message2,
                            ref: validateRef
                          };
                          nativeError(_message2);
                          return _context.abrupt("return", lastChild ? resolve(data) : data);

                        case 11:
                          return _context.abrupt("return", lastChild ? resolve(previous) : previous);

                        case 12:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x4, _x5, _x6) {
                  return _ref15.apply(this, arguments);
                };
              }(), {});
            });

          case 54:
            validationResult = _context2.sent;

            if (!(validationResult && !isEmptyObject(validationResult))) {
              _context2.next = 58;
              break;
            }

            error[name] = Object.assign({
              ref: validateRef
            }, validationResult);
            return _context2.abrupt("return", error);

          case 58:
            if (nativeValidation) ref.setCustomValidity('');
            return _context2.abrupt("return", error);

          case 60:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function validateField(_x, _x2, _x3) {
    return _ref13.apply(this, arguments);
  };
}();

function parseErrorSchema(error) {
  return error.inner.reduce(function (previous, current, index) {
    previous[current.path] = error.errors[index];
    return previous;
  }, {});
}

function validateWithSchema(_x7, _x8) {
  return _validateWithSchema.apply(this, arguments);
}

function _validateWithSchema() {
  _validateWithSchema = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee10(ValidationSchema, data) {
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.prev = 0;
            _context10.next = 3;
            return ValidationSchema.validate(data, {
              abortEarly: false
            });

          case 3:
            return _context10.abrupt("return", {});

          case 6:
            _context10.prev = 6;
            _context10.t0 = _context10["catch"](0);
            return _context10.abrupt("return", parseErrorSchema(_context10.t0));

          case 9:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[0, 6]]);
  }));
  return _validateWithSchema.apply(this, arguments);
}

function attachNativeValidation(ref, rules) {
  Object.entries(rules).forEach(function (_ref17) {
    var _ref18 = _slicedToArray(_ref17, 2),
        key = _ref18[0],
        value = _ref18[1];

    if (key === 'required') {
      ref[key] = true;
    } else if (key === 'pattern' && value instanceof RegExp) {
      ref[key] = value.source;
    } else {
      ref[key] = value;
    }
  });
}

function onDomRemove(element, onDetachCallback) {
  var observer = new MutationObserver(function () {
    function isDetached(element) {
      if (!element || !element.parentNode) return true;

      if (element.parentNode === window.document) {
        return false;
      } else if (element.parentNode === null) {
        return true;
      }

      return isDetached(element.parentNode);
    }

    if (isDetached(element)) {
      observer.disconnect();
      onDetachCallback();
    }
  });
  observer.observe(window.document, {
    childList: true,
    subtree: true
  });
  return observer;
}

var modeChecker = function modeChecker(mode) {
  return {
    isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
    isOnBlur: mode === VALIDATION_MODE.onBlur,
    isOnChange: mode === VALIDATION_MODE.onchange
  };
};

var warnMessage = function warnMessage(message) {
  if (process.env.NODE_ENV !== 'production') console.warn(message);
};

var useEffect = React.useEffect,
    useRef = React.useRef,
    useState = React.useState,
    useCallback = React.useCallback;

function useForm() {
  var _ref19 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    mode: 'onSubmit',
    defaultValues: {},
    nativeValidation: false,
    submitFocusError: true
  },
      mode = _ref19.mode,
      validationSchema = _ref19.validationSchema,
      defaultValues = _ref19.defaultValues,
      validationFields = _ref19.validationFields,
      nativeValidation = _ref19.nativeValidation,
      submitFocusError = _ref19.submitFocusError;

  var fieldsRef = useRef({});
  var errorsRef = useRef({});
  var submitCountRef = useRef(0);
  var touchedFieldsRef = useRef(new Set());
  var watchFieldsRef = useRef({});
  var isUnMount = useRef(false);
  var isWatchAllRef = useRef(false);
  var isSubmittingRef = useRef(false);
  var isSubmittedRef = useRef(false);
  var isDirtyRef = useRef(false);
  var isSchemaValidateTriggeredRef = useRef(false);
  var validateAndStateUpdateRef = useRef();
  var fieldsWithValidationRef = useRef(new Set());
  var validFieldsRef = useRef(new Set());
  var reRenderForm = useState({})[1];

  var _modeChecker = modeChecker(mode),
      isOnChange = _modeChecker.isOnChange,
      isOnBlur = _modeChecker.isOnBlur,
      isOnSubmit = _modeChecker.isOnSubmit;

  var combineErrorsRef = function combineErrorsRef(data) {
    return Object.assign({}, errorsRef.current, data);
  };

  var renderBaseOnError = function renderBaseOnError(name, errorsFromRef, error) {
    var shouldRender = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    if (errorsFromRef[name] && !error[name]) {
      delete errorsRef.current[name];
      validFieldsRef.current.add(name);
      if (shouldRender) reRenderForm({});
      return true;
    } else if (error[name]) {
      validFieldsRef.current.delete(name);
      if (shouldRender) reRenderForm({});
      return true;
    }

    if (!isOnSubmit && !validFieldsRef.current.has(name)) {
      validFieldsRef.current.add(name);
      if (shouldRender) reRenderForm({});
      return true;
    }

    return false;
  };

  var executeValidation =
  /*#__PURE__*/
  function () {
    var _ref21 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3(_ref20) {
      var name,
          value,
          shouldRender,
          field,
          errors,
          error,
          _args3 = arguments;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              name = _ref20.name, value = _ref20.value;
              shouldRender = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : true;
              field = fieldsRef.current[name];
              errors = errorsRef.current;

              if (field) {
                _context3.next = 6;
                break;
              }

              return _context3.abrupt("return", false);

            case 6:
              if (value !== undefined) setValue(name, value); // eslint-disable-line @typescript-eslint/no-use-before-define

              _context3.next = 9;
              return validateField(field, fieldsRef.current);

            case 9:
              error = _context3.sent;
              errorsRef.current = combineErrorsRef(error);
              renderBaseOnError(name, errors, error, shouldRender);
              return _context3.abrupt("return", isEmptyObject(error));

            case 13:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function executeValidation(_x9) {
      return _ref21.apply(this, arguments);
    };
  }();

  var executeSchemaValidation =
  /*#__PURE__*/
  function () {
    var _ref22 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee4(payload) {
      var fieldValues, fieldErrors, isArray, errors, payloadName, names;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              fieldValues = getFieldsValue(fieldsRef.current);
              _context4.next = 3;
              return validateWithSchema(validationSchema, fieldValues);

            case 3:
              fieldErrors = _context4.sent;
              isArray = Array.isArray(payload);

              if (isArray) {
                names = payload.map(function (_ref23) {
                  var name = _ref23.name;
                  return name;
                });
                errors = combineErrorsRef(Object.entries(fieldErrors).reduce(function (previous, _ref24) {
                  var _ref25 = _slicedToArray(_ref24, 2),
                      key = _ref25[0],
                      value = _ref25[1];

                  return (// @ts-ignore
                    names.includes(key) ? Object.assign({}, previous, _defineProperty({}, key, value)) : previous
                  );
                }, {}));
              } else {
                // @ts-ignore
                payloadName = payload.name;
                errors = combineErrorsRef(fieldErrors[payloadName] ? {
                  name: fieldErrors[payloadName]
                } : null);
              }

              errorsRef.current = errors;
              isSchemaValidateTriggeredRef.current = true;
              reRenderForm({});
              return _context4.abrupt("return", isArray ? isEmptyObject(fieldErrors) : !fieldErrors[payloadName]);

            case 10:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function executeSchemaValidation(_x10) {
      return _ref22.apply(this, arguments);
    };
  }();

  var triggerValidation =
  /*#__PURE__*/
  function () {
    var _ref26 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee6(payload) {
      var fields, result;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              fields = payload;
              if (!payload) fields = Object.keys(fieldsRef.current).map(function (name) {
                return {
                  name: name
                };
              });

              if (!validationSchema) {
                _context6.next = 4;
                break;
              }

              return _context6.abrupt("return", executeSchemaValidation(fields));

            case 4:
              if (!Array.isArray(fields)) {
                _context6.next = 10;
                break;
              }

              _context6.next = 7;
              return Promise.all(fields.map(
              /*#__PURE__*/
              function () {
                var _ref27 = _asyncToGenerator(
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee5(data) {
                  return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          _context5.next = 2;
                          return executeValidation(data, false);

                        case 2:
                          return _context5.abrupt("return", _context5.sent);

                        case 3:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee5);
                }));

                return function (_x12) {
                  return _ref27.apply(this, arguments);
                };
              }()));

            case 7:
              result = _context6.sent;
              reRenderForm({});
              return _context6.abrupt("return", result.every(Boolean));

            case 10:
              return _context6.abrupt("return", executeValidation(fields));

            case 11:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function triggerValidation(_x11) {
      return _ref26.apply(this, arguments);
    };
  }();

  var setFieldValue = function setFieldValue(name, value) {
    var field = fieldsRef.current[name];
    if (!field) return;
    var ref = field.ref;
    var options = field.options;

    if (isRadioInput(ref.type) && options) {
      options.forEach(function (_ref28) {
        var radioRef = _ref28.ref;
        if (radioRef.value === value) radioRef.checked = true;
      });
    } else {
      ref[isCheckBoxInput(ref.type) ? 'checked' : 'value'] = value;
    }
  };

  var setValue = function setValue(name, value) {
    var shouldValidate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    setFieldValue(name, value);
    touchedFieldsRef.current.add(name);
    isDirtyRef.current = true;
    reRenderForm({});
    if (shouldValidate) triggerValidation({
      name: name
    });
  };

  validateAndStateUpdateRef.current = validateAndStateUpdateRef.current ? validateAndStateUpdateRef.current :
  /*#__PURE__*/
  function () {
    var _ref30 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee7(_ref29) {
      var name, type, fields, errorsFromRef, ref, isBlurType, isValidateDisabled, shouldUpdateValidateMode, shouldUpdateState, result, fieldsErrors, error, shouldUpdate, _error, _shouldUpdate;

      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              name = _ref29.target.name, type = _ref29.type;

              if (!(Array.isArray(validationFields) && !validationFields.includes(name))) {
                _context7.next = 3;
                break;
              }

              return _context7.abrupt("return");

            case 3:
              fields = fieldsRef.current;
              errorsFromRef = errorsRef.current;
              ref = fields[name];

              if (ref) {
                _context7.next = 8;
                break;
              }

              return _context7.abrupt("return");

            case 8:
              isBlurType = type === 'blur';
              isValidateDisabled = !isSubmittedRef.current && isOnSubmit;
              shouldUpdateValidateMode = isOnChange || isOnBlur && isBlurType;
              shouldUpdateState = isWatchAllRef.current || watchFieldsRef.current[name];

              if (!isDirtyRef.current) {
                isDirtyRef.current = true;
                shouldUpdateState = true;
              }

              if (!touchedFieldsRef.current.has(name)) {
                touchedFieldsRef.current.add(name);
                shouldUpdateState = true;
              }

              if (!(isValidateDisabled && shouldUpdateState)) {
                _context7.next = 16;
                break;
              }

              return _context7.abrupt("return", reRenderForm({}));

            case 16:
              if (!validationSchema) {
                _context7.next = 30;
                break;
              }

              result = getFieldsValue(fields);
              _context7.next = 20;
              return validateWithSchema(validationSchema, result);

            case 20:
              fieldsErrors = _context7.sent;
              isSchemaValidateTriggeredRef.current = true;
              error = fieldsErrors[name];
              shouldUpdate = (!error && errorsFromRef[name] || error) && (shouldUpdateValidateMode || isSubmittedRef.current);

              if (!shouldUpdate) {
                _context7.next = 28;
                break;
              }

              errorsRef.current = Object.assign({}, errorsFromRef, _defineProperty({}, name, error));
              if (!error) delete errorsRef.current[name];
              return _context7.abrupt("return", reRenderForm({}));

            case 28:
              _context7.next = 38;
              break;

            case 30:
              _context7.next = 32;
              return validateField(ref, fields, nativeValidation);

            case 32:
              _error = _context7.sent;
              _shouldUpdate = shouldUpdateWithError({
                errors: errorsFromRef,
                error: _error,
                isValidateDisabled: isValidateDisabled,
                isOnBlur: isOnBlur,
                isBlurType: isBlurType,
                name: name
              });

              if (!(_shouldUpdate || shouldUpdateValidateMode)) {
                _context7.next = 38;
                break;
              }

              errorsRef.current = combineErrorsRef(_error);

              if (!renderBaseOnError(name, errorsRef.current, _error)) {
                _context7.next = 38;
                break;
              }

              return _context7.abrupt("return");

            case 38:
              if (shouldUpdateState) reRenderForm({});

            case 39:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function (_x13) {
      return _ref30.apply(this, arguments);
    };
  }();
  var removeEventListener = findRemovedFieldAndRemoveListener.bind(null, fieldsRef.current, touchedFieldsRef, fieldsWithValidationRef, validateAndStateUpdateRef.current);

  var setError = function setError(name, type, message, ref) {
    var errorsFromRef = errorsRef.current;
    var error = errorsFromRef[name];
    var isSameError = error && typeof error !== 'string' && error.type === type && error.message === message;

    if (!type && error) {
      delete errorsFromRef[name];
      reRenderForm({});
    } else if (!isSameError && type) {
      // @ts-ignore
      errorsFromRef[name] = {
        type: type,
        message: message,
        ref: ref,
        isManual: true
      };
      reRenderForm({});
    }
  };

  function registerIntoFieldsRef(elementRef, data) {
    if (elementRef && !elementRef.name) return warnMessage("\u26A0 Missing field name: ".concat(elementRef));
    var name = elementRef.name,
        type = elementRef.type,
        value = elementRef.value;

    if (!isOnSubmit && data && !isEmptyObject(data)) {
      fieldsWithValidationRef.current.add(name);
    }

    var _ref31 = data || {},
        _ref31$required = _ref31.required,
        required = _ref31$required === void 0 ? false : _ref31$required,
        _ref31$validate = _ref31.validate,
        validate = _ref31$validate === void 0 ? undefined : _ref31$validate;

    var inputData = Object.assign({}, data, {
      ref: elementRef
    });
    var fields = fieldsRef.current;
    var isRadio = isRadioInput(type);
    var field = fields[name];
    var existRadioOptionIndex = isRadio && field && Array.isArray(field.options) ? field.options.findIndex(function (_ref32) {
      var ref = _ref32.ref;
      return value === ref.value;
    }) : -1;
    if (!isRadio && field || isRadio && existRadioOptionIndex > -1) return;

    if (!type) {
      fields[name] = Object.assign({
        ref: {
          name: name
        }
      }, data);
    } else {
      if (isRadio) {
        if (!field) fields[name] = {
          options: [],
          required: required,
          validate: validate,
          ref: {
            type: 'radio',
            name: name
          }
        };
        if (validate) fields[name].validate = validate;
        (fields[name].options || []).push(Object.assign({}, inputData, {
          mutationWatcher: onDomRemove(elementRef, function () {
            return removeEventListener(inputData, true);
          })
        }));
      } else {
        fields[name] = Object.assign({}, inputData, {
          mutationWatcher: onDomRemove(elementRef, function () {
            return removeEventListener(inputData, true);
          })
        });
      }
    }

    if (defaultValues && defaultValues[name]) {
      setFieldValue(name, defaultValues[name]);
    }

    if (!type) return;
    var fieldData = isRadio ? (fields[name].options || [])[(fields[name].options || []).length - 1] : fields[name];
    if (!fieldData) return;

    if (nativeValidation && data) {
      attachNativeValidation(elementRef, data);
    } else {
      attachEventListeners({
        field: fieldData,
        isRadio: isRadio,
        validateAndStateUpdate: validateAndStateUpdateRef.current
      });
    }
  }

  function watch(fieldNames, defaultValue) {
    var watchFields = watchFieldsRef.current;

    if (typeof fieldNames === 'string') {
      watchFields[fieldNames] = true;
    } else if (Array.isArray(fieldNames)) {
      fieldNames.forEach(function (name) {
        watchFields[name] = true;
      });
    } else {
      isWatchAllRef.current = true;
      watchFieldsRef.current = {};
    }

    var values = getFieldsValue(fieldsRef.current, fieldNames);
    var result = values === undefined || isEmptyObject(values) ? undefined : values;
    return result === undefined ? defaultValue : result;
  }

  var register = useCallback(function (refOrValidateRule, validateRule) {
    if (!refOrValidateRule || typeof window === 'undefined') return;

    if (validateRule && !refOrValidateRule.name) {
      warnMessage(refOrValidateRule);
      return;
    }

    if (refOrValidateRule.name) {
      registerIntoFieldsRef(refOrValidateRule, validateRule);
    }

    return function (ref) {
      return ref && registerIntoFieldsRef(ref, refOrValidateRule);
    };
  }, []);

  var resetField = function resetField(name) {
    var field = fieldsRef.current[name];
    if (!field) return;
    var ref = field.ref,
        options = field.options;
    isRadioInput(ref.type) && Array.isArray(options) ? options.forEach(function (input) {
      return removeEventListener(input, true);
    }) : removeEventListener(ref, true);
    delete watchFieldsRef.current[name];
    delete errorsRef.current[name];
    delete fieldsRef.current[name];
    touchedFieldsRef.current.delete(name);
    fieldsWithValidationRef.current.delete(name);
    validFieldsRef.current.delete(name);
  };

  var unregister = function unregister(name) {
    Array.isArray(name) ? name.forEach(resetField) : resetField(name);
  };

  var handleSubmit = function handleSubmit(callback) {
    return (
      /*#__PURE__*/
      function () {
        var _ref33 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee9(e) {
          var fieldErrors, fieldValues, firstFocusError, fields, currentFieldValues, _ref34, errors, values;

          return _regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  if (e && !nativeValidation) {
                    e.preventDefault();
                    e.persist();
                  }

                  firstFocusError = true;
                  fields = fieldsRef.current;
                  currentFieldValues = validationFields ? validationFields.map(function (name) {
                    return fieldsRef.current[name];
                  }) : Object.values(fields);
                  isSubmittingRef.current = true;
                  reRenderForm({});

                  if (!validationSchema) {
                    _context9.next = 13;
                    break;
                  }

                  fieldValues = getFieldsValue(fields);
                  _context9.next = 10;
                  return validateWithSchema(validationSchema, fieldValues);

                case 10:
                  fieldErrors = _context9.sent;
                  _context9.next = 20;
                  break;

                case 13:
                  _context9.next = 15;
                  return currentFieldValues.reduce(
                  /*#__PURE__*/
                  function () {
                    var _ref35 = _asyncToGenerator(
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee8(previous, field) {
                      var resolvedPrevious, ref, name, fieldError;
                      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                        while (1) {
                          switch (_context8.prev = _context8.next) {
                            case 0:
                              if (field) {
                                _context8.next = 2;
                                break;
                              }

                              return _context8.abrupt("return", previous);

                            case 2:
                              _context8.next = 4;
                              return previous;

                            case 4:
                              resolvedPrevious = _context8.sent;
                              ref = field.ref, name = field.ref.name;

                              if (fields[name]) {
                                _context8.next = 8;
                                break;
                              }

                              return _context8.abrupt("return", Promise.resolve(resolvedPrevious));

                            case 8:
                              _context8.next = 10;
                              return validateField(field, fields, nativeValidation);

                            case 10:
                              fieldError = _context8.sent;

                              if (!fieldError[name]) {
                                _context8.next = 15;
                                break;
                              }

                              if (submitFocusError && firstFocusError && ref.focus) {
                                ref.focus();
                                firstFocusError = false;
                              }

                              resolvedPrevious.errors = Object.assign({}, resolvedPrevious.errors || {}, fieldError);
                              return _context8.abrupt("return", Promise.resolve(resolvedPrevious));

                            case 15:
                              resolvedPrevious.values[name] = getFieldValue(fields, ref);
                              return _context8.abrupt("return", Promise.resolve(resolvedPrevious));

                            case 17:
                            case "end":
                              return _context8.stop();
                          }
                        }
                      }, _callee8);
                    }));

                    return function (_x15, _x16) {
                      return _ref35.apply(this, arguments);
                    };
                  }(), Promise.resolve({
                    errors: {},
                    values: {}
                  }));

                case 15:
                  _ref34 = _context9.sent;
                  errors = _ref34.errors;
                  values = _ref34.values;
                  fieldErrors = errors;
                  fieldValues = values;

                case 20:
                  if (!isUnMount.current) {
                    _context9.next = 22;
                    break;
                  }

                  return _context9.abrupt("return");

                case 22:
                  if (!isEmptyObject(fieldErrors)) {
                    _context9.next = 28;
                    break;
                  }

                  errorsRef.current = {};
                  _context9.next = 26;
                  return callback(combineFieldValues(fieldValues), e);

                case 26:
                  _context9.next = 29;
                  break;

                case 28:
                  errorsRef.current = fieldErrors;

                case 29:
                  isSubmittedRef.current = true;
                  submitCountRef.current += 1;
                  isSubmittingRef.current = false;
                  reRenderForm({});

                case 33:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9);
        }));

        return function (_x14) {
          return _ref33.apply(this, arguments);
        };
      }()
    );
  };

  var resetRefs = function resetRefs() {
    watchFieldsRef.current = {};
    errorsRef.current = {};
    isWatchAllRef.current = false;
    isSubmittedRef.current = false;
    isDirtyRef.current = false;
    touchedFieldsRef.current = new Set();
    fieldsWithValidationRef.current = new Set();
    validFieldsRef.current = new Set();
    submitCountRef.current = 0;
    isSchemaValidateTriggeredRef.current = false;
  };

  var unSubscribe = function unSubscribe() {
    fieldsRef.current && Object.values(fieldsRef.current).forEach(function (field) {
      if (!field) return;
      var ref = field.ref,
          options = field.options;
      isRadioInput(ref.type) && Array.isArray(options) ? options.forEach(function (fieldRef) {
        return removeEventListener(fieldRef, true);
      }) : removeEventListener(field, true);
    });
    fieldsRef.current = {};
    resetRefs();
  };

  var reset = useCallback(function () {
    var fields = Object.values(fieldsRef.current);

    for (var _i = 0, _fields = fields; _i < _fields.length; _i++) {
      var field = _fields[_i];

      if (field && field.ref.closest) {
        field.ref.closest('form').reset();
        break;
      }
    }

    resetRefs();
    reRenderForm({});
  }, []);

  var getValues = function getValues() {
    return getFieldsValue(fieldsRef.current);
  };

  useEffect(function () {
    return function () {
      isUnMount.current = true;
      unSubscribe();
    };
  }, [mode, isUnMount.current]);
  var isEmptyErrors = isEmptyObject(errorsRef.current);
  return {
    register: register,
    unregister: unregister,
    handleSubmit: handleSubmit,
    watch: watch,
    unSubscribe: unSubscribe,
    reset: reset,
    clearError: function clearError(name) {
      setError(name);
    },
    setError: setError,
    setValue: setValue,
    triggerValidation: triggerValidation,
    getValues: getValues,
    errors: errorsRef.current,
    formState: Object.assign({
      dirty: isDirtyRef.current,
      isSubmitted: isSubmittedRef.current,
      submitCount: submitCountRef.current,
      // @ts-ignore
      touched: _toConsumableArray(touchedFieldsRef.current),
      isSubmitting: isSubmittingRef.current
    }, isOnSubmit ? {
      isValid: isEmptyErrors
    } : {
      isValid: validationSchema ? isSchemaValidateTriggeredRef.current && isEmptyErrors : fieldsWithValidationRef.current.size ? !isEmptyObject(fieldsRef.current) && validFieldsRef.current.size >= fieldsWithValidationRef.current.size : !isEmptyObject(fieldsRef.current)
    })
  };
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */


function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
}

var FormGlobalContext = createContext({});

var useFormContext = function useFormContext() {
  return useContext(FormGlobalContext);
};

function FormContext(props) {
  var children = props.children,
      rest = __rest(props, ["children"]);

  return createElement(FormGlobalContext.Provider, {
    value: Object.assign({}, rest)
  }, children);
}

export default useForm;
export { FormContext, useFormContext };